<template>
  <span v-if="svg" class="tu-lang-flag" aria-hidden="true" v-html="svg" />
  <tu-ui-icon v-else name="chats" :size="16" />
</template>

<script>
import TuUiIcon from '@/tu/components/UiIcon.vue'

// Flat flags drawn inline (emoji flags render as letters on Windows). Keyed by path language code.
const FLAGS = {
  es: '<svg viewBox="0 0 3 2"><rect width="3" height="2" fill="#AA151B"/><rect y=".5" width="3" height="1" fill="#F1BF00"/></svg>',
  fr: '<svg viewBox="0 0 3 2"><rect width="3" height="2" fill="#CE1126"/><rect width="2" height="2" fill="#fff"/><rect width="1" height="2" fill="#002654"/></svg>',
  de: '<svg viewBox="0 0 5 3"><rect width="5" height="3" fill="#FFCE00"/><rect width="5" height="2" fill="#DD0000"/><rect width="5" height="1" fill="#000"/></svg>',
  it: '<svg viewBox="0 0 3 2"><rect width="3" height="2" fill="#CE2B37"/><rect width="2" height="2" fill="#fff"/><rect width="1" height="2" fill="#009246"/></svg>',
  ru: '<svg viewBox="0 0 3 2"><rect width="3" height="2" fill="#D52B1E"/><rect width="3" height="1.333" fill="#0039A6"/><rect width="3" height=".667" fill="#fff"/></svg>',
  pl: '<svg viewBox="0 0 8 5"><rect width="8" height="5" fill="#DC143C"/><rect width="8" height="2.5" fill="#fff"/></svg>',
  vi: '<svg viewBox="0 0 30 20"><rect width="30" height="20" fill="#DA251D"/><polygon fill="#FF0" points="15,4 16.76,9.43 22.47,9.43 17.85,12.79 19.62,18.21 15,14.86 10.38,18.21 12.15,12.79 7.53,9.43 13.24,9.43"/></svg>'
}

/** Flag for a path language code, falling back to the chat icon when there is no flag. */
export default {
  name: 'TuLangFlag',
  components: { TuUiIcon },
  props: { code: { type: String, default: '' } },
  computed: { svg() { return FLAGS[this.code] || '' } }
}
</script>

<style scoped>
.tu-lang-flag { display: inline-flex; width: 22px; height: 15px; border-radius: 3px; overflow: hidden; box-shadow: 0 0 0 1px rgba(0, 0, 0, .08); flex: none; }
.tu-lang-flag ::v-deep svg { width: 100%; height: 100%; display: block; }
</style>
